<template>
  <div>
    <b-modal id="modalEditCoefficientScheme" ref="modalEditCoefficientScheme" :title="$t('Coefficient scheme detail')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.comment"/>
        </b-form-group>

        <b-form-group :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-button variant="success" style="float: right" size="sm" @click="addCost">{{ $t('Add') }}</b-button>
        </b-form-group>
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Since') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('Till') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('Coefficient') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('Actions') }}</h4>
            </b-col>
          </b-row>
          <b-row v-for="item in this.editItem.items" :key="item.id" style="padding: 2px">
            <b-col>
              <b-input v-model="item.delay"/>
            </b-col>
            <b-col>
              <b-input v-model="item.duration"/>
            </b-col>
            <b-col>
              <b-input v-model="item.coeff"/>
            </b-col>
            <b-col>
              <b-button size="sm" id="transparent" @click="deleteCostsValue(item)">
                <b-img :src='deleteCost'/>
              </b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save') }}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$refs.modalEditCoefficientScheme.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      numCost: 1000000,
      deleteCost: require('@/assets/img/document_delete.png')
    }
  },
  methods: {
    addCost () {
      let newCost = {
        'num': 0,
        'scheme_id': 0,
        'delay': 0,
        'duration': 0,
        'coeff': 1
      }
      newCost.num = ++this.numCost
      if (this.editItem.id > 0) {
        newCost.scheme_id = this.editItem.id
      }
      this.editItem.items.push(newCost)
    },
    deleteCostsValue (item) {
      this.editItem.items = this.editItem.items.filter((el) => {
        return el.num !== item.num
      })
    },
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      this.editItem.costs = []
      for (let el of this.editItem.items) {
        let newEl = {
          delay: 0,
          duration: 0,
          coeff: 0,
          scheme_id: 0
        }
        newEl.delay = Number(el.delay)
        newEl.duration = Number(el.duration)
        newEl.coeff = Number(el.coeff)
        newEl.scheme_id = el.scheme_id
        this.editItem.costs.push(newEl)
      }
      this.editItem.coeff_scheme_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Tariffing/UPDATE_COEFFICIENT_SCHEME', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_COEFFICIENT_SCHEME', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_COEFFICIENT_SCHEME')
          this.$refs.modalEditCoefficientScheme.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/additional/coefficientScheme/editModal.vue